export default __webpack_public_path__ + "static/media/mandala2.2030760f.jpg";